import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { ToastService } from '../shared/toast.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
   videoUrl!: SafeResourceUrl;

 email: string = '';
  code: string = '';
  newPassword: string = '';

  step: number = 1; // 1 = email, 2 = verify code, 3 = reset password

  resetFailed = false;
  resetSuccess = false;

  verifyFailed = false;
  verifySuccess = false;

  resetPwdFailed = false;
  resetPwdSuccess = false;

  hasUppercase = false;
hasLowercase = false;
hasNumber = false;
hasSpecialChar = false;
hasMinLength = false;

  constructor(private commonService: CommonService, private router: Router, private toast: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
     const youtubeLink = 'https://www.youtube.com/embed/rL4zzMLGBCs';
     this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeLink);
  }

  // Step 1: Forgot password (send code)
  onForgotPassword(): void {
    this.resetFailed = this.resetSuccess = false;

    this.commonService.forgotPassword({ email: this.email }).subscribe({
      next: (res) => {
        console.log('Code sent:', res);
        this.resetSuccess = true;
        this.step = 2; // move to verify step
      },
      error: (err) => {
        console.error('Forgot password failed:', err);
        this.resetFailed = true;
      }
    });
  }

  // Step 2: Verify reset code
  onVerifyCode(): void {
    this.verifyFailed = this.verifySuccess = false;

    this.commonService.verifyResetCode({ email: this.email, code: this.code }).subscribe({
      next: (res) => {
        console.log('Code verified:', res);
        this.verifySuccess = true;
        this.step = 3; // move to reset password
      },
      error: (err) => {
        console.error('Verify code failed:', err);
        this.verifyFailed = true;
      }
    });
  }

  // Step 3: Reset password
 onResetPassword(): void {

  if (!(this.hasUppercase && this.hasLowercase && this.hasNumber && this.hasSpecialChar && this.hasMinLength)) {
    this.toast.showError('Password does not meet security requirements');
    return;
  }

  this.resetPwdFailed = this.resetPwdSuccess = false;

  const payload = {
    email: this.email,
    code: this.code,
    newPassword: this.newPassword
  };

  this.commonService.resetPassword(payload).subscribe({
    next: (res: any) => {
      this.resetPwdSuccess = true;
      this.toast.showSuccess(res.message);

      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 2000);
    },
    error: (err) => {
      this.resetPwdFailed = true;
      this.toast.showError(err.error?.message || 'Something went wrong');
    }
  });
}


checkPasswordStrength() {
  const password = this.newPassword || '';

  this.hasUppercase = /[A-Z]/.test(password);
  this.hasLowercase = /[a-z]/.test(password);
  this.hasNumber = /[0-9]/.test(password);
  this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  this.hasMinLength = password.length >= 8;
}

}
